/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { simulatedTransaction } from "../simulated-transaction"

type MintFertilizerClFarmLiquidityProps = {
  account: Address
  chainId: number
  config: Config
  vaultAddress: Address
  mintToken0AmountBI: bigint
  mintToken1AmountBI: bigint
  slippageBI: bigint
}

const depositAbi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_a0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_a1",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_msh",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "uint256",
        name: "_shares",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const

export const mintFertilizerClFarmLiquidity = async ({
  account,
  chainId,
  config,
  vaultAddress,
  mintToken0AmountBI,
  mintToken1AmountBI,
  slippageBI,
}: MintFertilizerClFarmLiquidityProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: depositAbi as Abi,
        account,
        chainId,
        address: vaultAddress,
        functionName: "deposit",
        args: [mintToken0AmountBI, mintToken1AmountBI, slippageBI],
      },
    })
    return result
  } catch (error: any) {
    console.error("mintFertilizerClFarmLiquidity", error)
    return { success: false, error: error.message, code: error.code }
  }
}
